import { render, staticRenderFns } from "./DatasetCollectionContents.vue?vue&type=template&id=676f0b6a&"
import script from "./DatasetCollectionContents.vue?vue&type=script&lang=js&"
export * from "./DatasetCollectionContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports